export default function(ngModule) {
    ngModule.factory('PaymentMethod', function(BaseClass,$q, $http, BCCacheable, Role) {
        /**
         * Constructor function
         *
         * @param {Object} attributes Initial attributes for the model
         */
        function PaymentMethod(attributes) {
            _.assign(this,attributes);
        }
        PaymentMethod.modelName = 'PaymentMethod';

        BaseClass.apply(PaymentMethod);

        PaymentMethod.configureApi('/paymentmethod/:guid', { queryAdmin: '/paymentmethod/company/:company' });

        PaymentMethod.prototype.isStripe = function() {
            return this.stripe_public_key && this.stripe_public_key.length > 0;
        };

        PaymentMethod.queryWhitelabelMethods = function(whitelabelId = null) {
            if (!Role.isAdmin) {
                return $q.reject('Not allowed');
            }

            let url = '/paymentmethod/whitelabel';

            if (whitelabelId) {
                url += `/${whitelabelId}`;
            }

            return $http.get(url).then(response => _.map(response.data, method => PaymentMethod.new(method)));
        };

        return PaymentMethod;
    });
}
